import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover, Select, Radio, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import HierarchicalDropdown from '../Roles/HierarchicalDropdown';
import AwsServerService from '../../common/util/AwsServerService';

const { Option } = Select;

export default function AccessControl({ FlowID }) {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [error, setError] = useState(false);
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const [teams,setTeams] = useState([]);
  const [dataToShow,setDataToShow] = useState([]);
  const [accessList, setAccessList] = useState([{ id: Date.now(), target: [], access: 'read' }]);
 
  useEffect(()=>{
   getDataForAccess();
   AwsServerService.CrudServiceHandler({method:'GET',data:'',route:'TEAMS'}).then(res=>{
     if (res?.data?.length > 0) {
       setTeams(res?.data);
      }
    }).catch(err=>console.log('err',err))  
  },[])
  function getDataForAccess() { 
    if(FlowID){
      AwsServerService.CrudServiceHandler({method:'GETWHERE',data:{FlowID:FlowID},route:'ACCESSCONTROL'}).then(res=>{
          
        setDataToShow(res.data[0]||[]);
      })
    }
  } 
  
  const handleChange = (id, key, value) => { 
    setError(false);
    setAccessList(prev =>
      prev.map(row =>
        row.id === id ? { ...row, [key]: value } : row
      )
    );
  };
  const handleSave = () =>{ 
    if(dataToShow && dataToShow.ROWID){ 
      let data = [...accessList];
      const payload = {
        ROWID:dataToShow.ROWID, 
        AccessData:JSON.stringify(data),
        MODIFIEDBY:userinfo?.zuid
      }
      AwsServerService.CrudServiceHandler({method:'PUT',data:payload,route:'ACCESSCONTROL'}).then(res=>{
        setOpen(false);
        getDataForAccess() 
        })
    }else{ 
    let data = [...accessList];
    const payload = {
      FlowID:FlowID,
      AccessData:JSON.stringify(data),
      CREATEDBY:userinfo?.zuid  
    }
    AwsServerService.CrudServiceHandler({method:'POST',data:payload,route:'ACCESSCONTROL'}).then(res=>{
      setOpen(false);
      getDataForAccess() 
      })
    }
    setEdit(false);
  }

  const addRow = () => {
    const hasEmpty = accessList.some(row => !row.target || row.target.length === 0);
    if (hasEmpty) {
      setError(true);
      return;
    } 
    setAccessList(prev => [
      ...prev,
      { id: Date.now(), target: [], access: 'read' },
    ]);
  };

  const removeRow = id => {
    setAccessList(prev => prev.filter(row => row.id !== id));
  };

  const content = () => {
    return (
      <div style={{ minWidth: 'max-content'}}>
        {accessList.map((row, index) => (
          <div key={row.id} className="main-access-wrapper"> 
            <div  style={{ position: 'relative',width:'23rem' }}>
              <label className="d-block" style={{position:'absolute',top:'-8px',left:'2px',background:'white',
                padding: '0 4px',fontSize: '12px',color: '#888',zIndex: 1,}} >Select</label>
              <HierarchicalDropdown 
                GroupName={["Role","Zoho","Teams","Task"]} 
                handleChangeUser={(value)=>handleChange(row.id, 'target', value)}
                selectedUsers={row.target}
                placeholder={"Select Assignee"}
                isMulti={true} 
                extraStyle={true} 
                styles={{width:'100%',height:'auto'}} />  
            </div> 
            <div className='radioGroup'> 
                <Radio.Group
                  value={row.access}
                  onChange={e =>
                    handleChange(row.id, 'access', e.target.value)
                  }
                >
                  <Radio value="read">Read</Radio>
                  <Radio value="write">Write</Radio>
                </Radio.Group> 
            </div> 
            <div className="plusminusiconsrendering" >
            {accessList.length == 1 ? (<Button
                type="text"
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={addRow}
              />) : (
                <Button
                  type="text"
                  icon={<FontAwesomeIcon icon={faMinus} />}
                  onClick={() => removeRow(row.id)}
                />
              )}
            </div>
          </div>
        ))}
        <Row style={{ display: "flex", justifyContent: "flex-end", padding: "5px", marginTop:'1rem' }}>
            {error && <small style={{width: 'auto',position: 'relative',right: '10em',color: 'red'}}> Please complete selection from the select box first.</small>}
            <Button style={{ width: "auto", padding: "6px" }} className='mr-1'
                onClick={e=>{ setOpen(false);setAccessList([{ id: Date.now(), target: [], access: 'read' }])}}
            >Cancel</Button>
            <Button type='primary' style={{ width: "auto", padding: "6px", marginRight: '1rem' }} className='ml-1'
                onClick={e=>handleSave()}
            >{edit?'Update':'Save'}</Button>
        </Row> 
      </div>
    );
  };
  

  return (<>
  <div className='plusButtonForAccess'> 
    <Popover
      title={"ASSIGN ACCESS"}
      placement="leftBottom"
      open={open}
      onOpenChange={e => setOpen(e)}
      className="Input-Field-Popover-Main2"
      overlayClassName="Input-Field-Popover2"
      destroyTooltipOnHide={true}
      trigger="click"
      content={content}
    >
      <div className="Card Add-Icon" onClick={() => {
        if(dataToShow.AccessData.length>0){
          setAccessList([...dataToShow.AccessData])
        }else{
          setAccessList([{ id: Date.now(), target: [], access: 'read' }])
        }
        setOpen(true)}}>
        <FontAwesomeIcon style={{ marginRight: "7px" }} icon={faPlus} />
        {"Add"}
      </div>
    </Popover>
    </div>
    <div style={{display:'contents'}}>{ 
                 <div className='Card'>
                    <div style={{
                      display: "flex",
                      "align-items": "center",
                    }} onClick={e => { 
                      setOpen(true)
                      setEdit(true);
                      setAccessList([...dataToShow.AccessData]);
                    }}>
                        {'View'}
                      </div> 
                  </div>
              }
              </div>
    </>
  );
}
